import { useEffect, useState } from "react";
import { getCountries } from "../../../../store/middleware";
import { useDispatch } from "react-redux";

function Country(props) {
  const fieldName = "countryId";

  const [countries, setCountries] = useState([]);

  const dispatch = useDispatch();

  const loadInfos = () => {
    dispatch(getCountries()).then((res) => setCountries(res));
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  const { t, handleChange } = props;
  const { item } = props;
  return (
    <div className="lineInputs">
      <div>
        <label>
          {t("COUNTRY")}
          <span className="invalid">{t("REQUIRED_FIELD")}</span>
        </label>
      </div>
      <select value={item.countryId} onChange={handleChange} className="input-lingo mediumSelect" name={fieldName}>
        <option>Select</option>
        {countries.map((i) => {
          return (
            <option key={i.id} value={i.id}>
              {i.name}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default Country;
